module.exports = {
  md: {
    key: 'md',
    label: 'Doctor of Medicine',
  },
  do: {
    key: 'do',
    label: 'Doctor of Osteopathic Medicine',
  },
  pharmD: {
    key: 'pharmD',
    label: 'Doctor of Pharamacy',
  },
  dnp: {
    key: 'dnp',
    label: 'Doctor of Nursing Practice',
  },
  rn: {
    key: 'rn',
    label: 'Registered Nurse',
  },
  cna: {
    key: 'cna',
    label: 'Certified Nursing Assistant',
  },
  dpt: {
    key: 'dpt',
    label: 'Doctor of Physical Therapy',
  },
  otd: {
    key: 'otd',
    label: 'Doctor of Occupational Therapy',
  },
  psyd: {
    key: 'psyd',
    label: 'Doctor of Psychology',
  },
  phd: {
    key: 'phd',
    label: 'Doctor of Philosophy',
  },
  np: {
    key: 'np',
    label: 'Nurse Practitioner',
  },
  bsn: {
    key: 'bsn',
    label: 'Bachelor of Science in Nursing',
  },
  adn: {
    key: 'adn',
    label: 'Associate Degree in Nursing',
  },
  lpn: {
    key: 'lpn',
    label: 'Licensed Practical Nurse',
  },
  msn: {
    key: 'msn',
    label: 'Master of Science in Nursing',
  },
  cns: {
    key: 'cns',
    label: 'Clinical Nurse Specialist',
  },
  crna: {
    key: 'crna',
    label: 'Nurse Anesthetist',
  },
};